import { render } from "./TreePersonView.vue?vue&type=template&id=82678672&scoped=true"
import script from "./TreePersonView.vue?vue&type=script&lang=js"
export * from "./TreePersonView.vue?vue&type=script&lang=js"

import "./TreePersonView.vue?vue&type=style&index=0&id=82678672&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82678672"]])

export default __exports__